import { VpIcon } from '@vtmn-play/react';
import { useTranslation } from 'react-i18next';

import { SpoSmSheetResponse } from '@spo/types';
import { SmInfoContainer } from '../SmInfoContainer';
import { SmInfoDisplay } from '../smInfoDisplay';
import { CustomZoneSelection } from './CustomZoneSelection';
import './smSalesInfos.scss';

export interface SmSalesInfosProps {
  sm: SpoSmSheetResponse | undefined;
  isLoading: boolean;
}

const DisplayPrice = ({ sm }: { sm: SpoSmSheetResponse | undefined }) => {
  const { t } = useTranslation();

  if (sm?.price && sm.currency) {
    return `${Number(sm?.price).toFixed(2)} ${sm?.currency}`;
  }
  if (sm?.price && !sm?.currency) {
    return (
      <>
        {Number(sm.price).toFixed(2)}
        <span className="missing-currency">
          {t('sm-info.missing-currency')}
        </span>
      </>
    );
  }
  return t('sm-info.missing-information');
};

export const SmSalesInfos = ({ sm, isLoading }: SmSalesInfosProps) => {
  const { t } = useTranslation();

  return (
    <SmInfoContainer
      title={t('sm-info.sales-infos')}
      icon={<VpIcon name="shopping-cart" />}
    >
      <SmInfoDisplay label={t('sm-info.cz-reference')} isLoading={isLoading}>
        {sm?.referenceCustomZone || t('sm-info.missing-information')}
      </SmInfoDisplay>
      <div className="sm-info-main-line">
        <SmInfoDisplay label={t('sm-info.catalog-price')} isLoading={isLoading}>
          <DisplayPrice sm={sm} />
        </SmInfoDisplay>
        <SmInfoDisplay label={t('sm-info.margin')} isLoading={isLoading}>
          {`${sm?.margin}%`}
        </SmInfoDisplay>
      </div>
      <SmInfoDisplay label={t('sm-info.quantities')} isLoading={isLoading}>
        {sm?.quantity}
      </SmInfoDisplay>
      <>
        {sm?.customZones?.length && (
          <CustomZoneSelection customZonesIds={sm?.customZones} />
        )}
      </>
    </SmInfoContainer>
  );
};
